import { ReactNode } from "react";
import classes from '../styles/portfolio.module.css';

type ContentHeadingProps = {
  children?: ReactNode,
  title: string,
  type?: string | null,
}

const ContentHeading = ({
  children,
  title,
  type,
}: ContentHeadingProps) => {
  return (
    <div className={classes.contentHeading}>
      <h2 className={classes.h2}>
        {title}
        {type ? ` ${type}` : ''}
      </h2>
      {children}
    </div>
  );  
};

export default ContentHeading;
